import { MessageTemplateCategoriesEnum } from "@sinch/core/entities/serverEnums";
import { MessageTemplateCategoriesEnum as MessageTemplateCategoriesEnumType } from "@sinch/core/entities/serverEnums.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";
import { NotificationChannel } from "@sinch/components/application/Messages/useMessageChannels";

/**
 * Single source of truth for how a message template category looks in the app: label.
 *
 * Use these getters wherever a message template category is shown.
 * Never hardcode its label in a component, change them here.
 * Every value is shown in the "Entity Identity/MessageTemplateCategory" story.
 */
export const useMessageTemplateCategories = () => {
  const { t } = useTranslation();

  const messageTemplateCategories = {
    [MessageTemplateCategoriesEnum.OrderPublished]: {
      label: t("MessageTemplateCategories.orderPublished"),
      channels: [NotificationChannel.Push],
    },
  } as Record<MessageTemplateCategoriesEnumType, { label: string; channels: NotificationChannel[] }>;

  const getProp = useEntityProps(messageTemplateCategories);

  const getCategoryLabel = getProp<string>("label");
  const getCategoryAvailableChannels = getProp<NotificationChannel[]>("channels");
  const getSortedCategories = () => Object.keys(messageTemplateCategories) as MessageTemplateCategoriesEnum[];

  return { getCategoryLabel, getCategoryAvailableChannels, getSortedCategories };
};
